{
  "BuyPlayer_BuyOffer": "Kaufen",
  "BuyPlayer_InsufficientFundsTitle": "Budget reicht nicht aus",
  "BuyPlayer_NoDiscount": "kein Rabatt",
  "BuyPlayer_Success": "Kauf des Spielers erfolgreich",
  "Error_AppUpdateRequired": "Update deine App!",
  "Error_ConflictDuplicateLogin": "Dieser User ist schon angemeldet.",
  "Error_NetworkTimeout": "Überprüfe deine Internetverbindung!",
  "Error_TryLater": "Aktuell gibt es technische Probleme. Bitte versuche es später noch einmal.",
  "GameLoopState_Active": "Während Spieltag",
  "GameLoopState_Post": "Nach Spieltag",
  "GameLoopState_Pre": "Vor Spieltag",
  "General_Cancel": "Abbrechen",
  "General_Ok": "OK",
  "Lineup_Formation_1343": "3-4-3",
  "Lineup_Formation_1352": "3-5-2",
  "Lineup_Formation_1433": "4-3-3",
  "Lineup_Formation_1442": "4-4-2",
  "Lineup_Formation_1451": "4-5-1",
  "Lineup_Formation_1532": "5-3-2",
  "Lineup_InvalidLineup": "Ungültige Aufstellung",
  "LoadingOverlay_Title": "Wird geladen...",
  "AuthErrorPleaseContact": "Bei Fragen wende dich gerne an",
  "PlayerCard_Age": "{0} Jahre",
  "PlayerCard_AgeLabel": "Alter",
  "PlayerCard_Height": "{0} cm",
  "PlayerCard_HeightLabel": "Größe",
  "PlayerCard_NationalityLabel": "Land",
  "PlayerCard_ShirtNumberLabel": "Trikotnummer",
  "PlayerCard_TeamLabel": "Team",
  "PlayerCard_Weight": "{0} kg",
  "PlayerCard_WeightLabel": "Gewicht",
  "PlayerDetails_AddToLineup": "Aufstellen",
  "PlayerDetails_AssignedTo": "Eingesetzt in",
  "PlayerDetails_Back": "Zurück",
  "PlayerDetails_BuyHeadline": "Kauf angebot",
  "PlayerDetails_LockCountdown": "Transfersperre",
  "PlayerDetails_RemoveFromLineup": "Runter",
  "PlayerDetails_Roster": "Kader",
  "PlayerFilter_Name": "Name",
  "PlayerFilter_Price": "Marktwert",
  "PlayerFilter_Rating": "Durchschnitt",
  "PlayerGroup_ShowMore": "Alle anzeigen",
  "PlayerPosition_bench": "Ersatzbank",
  "PlayerPosition_defender": "Abwehr",
  "PlayerPosition_forward": "Sturm",
  "PlayerPosition_goalkeeper": "Tor",
  "PlayerPosition_midfielder": "Mittelfeld",
  "PlayerPosition_unknown": "Unbekannt",
  "Roster_RosterTitle": "Mein Kader",
  "RosterList_EmptyPosition": "Du hast keinen Spieler auf dieser Position",
  "RosterList_EmptyPositionButton": "Zum Transfermarkt",
  "SellPlayer_IsInLineupError": "Aufgestellte Spieler können währen des laufenden Spieltags nicht verkauft werden.",
  "SellPlayer_LockedError": "Der Spieler ist noch gesperrt.",
  "SellPlayer_Sell": "Verkaufen",
  "SellPlayer_SellMore": "Verkaufen",
  "StatusInformation_Reload": "Neu laden",
  "Transaction_BoughtLabel": "Gekauft",
  "TransactionNotification_AttentionWarning": "Achtung!",
  "TransactionNotification_BoughtHeadline": "Gekauft!",
  "TransactionNotification_BoughtText": "{0} (x{1}) für {2} gekauft!",
  "TransactionNotification_HardAndSoftPrice": "{0} und {1}",
  "TransactionNotification_SoldHeadline": "Verkauft!",
  "TransactionNotification_SoldText": "{0} (x{1}) für {2} verkauft!",
  "UserAuthenticateFailed": "Anmeldung fehlgeschlagen",
  "UserSettings_Off": "Aus",
  "UserSettings_On": "An",
  "UserSettings_Sound": "Musik",
  "UserSettings_Title": "Einstellungen",
  "UserSettings_Vibration": "Vibration",
  "ActionMenu_SubstituteOut": "Auswechseln",
  "Availability_available": "Verfügbar",
  "Availability_today": "Heute",
  "Availability_tomorrow": "Morgen",
  "Error_GameLoopState_Locked": "Der Transfermarkt ist geschlossen.",
  "ExperienceLog_Reward": "Belohnung",
  "ExperienceLog_Start": "Start",
  "GamedayPlayer_Status_bench": "Ersatzbank",
  "GamedayPlayer_Status_bench_Unsure": "Ersatzbank",
  "GamedayPlayer_Status_inactive": "Nicht im Kader",
  "GamedayPlayer_Status_inactive_Unsure": "Nicht im Kader",
  "GamedayPlayer_Status_questionable": "Einsatz fraglich",
  "GamedayPlayer_Status_questionable_Unsure": "Einsatz fraglich",
  "GamedayPlayer_Status_starter": "Startelf",
  "GamedayPlayer_Status_starter_Unsure": "Startelf",
  "GamedayPlayer_Status_unknown": "Unbekannt",
  "GamedayPlayer_Status_unknown_Unsure": "Unbekannt",
  "Gameloop_AdminGift": "Geschenk",
  "Gameloop_ClaimGiftFailedText": "Die Belohnung kann erst nach dem Ablauf der Frist abgeholt werden!",
  "Gameloop_LoginGift": "Tägliche Belohnung",
  "General_AreYouSure": "Bist du sicher?",
  "General_BuyOffer": "Kaufen",
  "General_Close": "Schliessen",
  "General_GamedateSeparatorForDays": "{0}. - {1}",
  "General_GamedateSeparatorForMonths": "{0} - {1}",
  "General_GamedayCurrent": "Aktueller Spieltag",
  "General_Info": "Info",
  "General_No": "Nein",
  "General_Warning": "Achtung!",
  "General_Yes": "Ja",
  "GeneralDate_CountdownDay": "{0} Tag {1}:{2}",
  "GeneralDate_CountdownDays": "{0} Tage {1}:{2}",
  "GeneralDate_CountdownDaysText": "{0} Tagen, {1} Std.",
  "GeneralDate_CountdownDayText": "{0} Tag, {1} Std.",
  "GeneralDate_CountdownHoursText": "{0} Std. {1} Min.",
  "GeneralDate_CountdownMinutesText": "{0} Min.",
  "GeneralDate_CountdownOfferText_One": "Neues Angebot in {0}",
  "GeneralDate_CountdownOfferText_Other": "Neue Angebote in {0}",
  "GeneralDate_CountdownSecondsText": "<1 Min.",
  "GeneralDate_Now": "Jetzt verfügbar",
  "GiftboxOverlay_Text": "Hol dir deine Belohung ab!",
  "GiftboxOverlay_Title": "Deine Belohnung",
  "GiftboxPreviewOverlay_Title": "Vorschau der Belohnung",
  "GiftboxType_AdminGift": "Geschenk",
  "GiftboxType_Combined": "Belohnung",
  "GiftboxType_GlobalRank": "Tabellenplatz",
  "GiftboxType_GlobalTableSection": "Tabellenbereich",
  "GiftboxType_GlobalTopManager": "Top Manager",
  "GiftboxType_GroupWinner": "Ligensieger",
  "GiftboxType_LevelUp": "Level Aufstieg",
  "GiftboxType_LoginGift": "Tägliche Belohnung",
  "Lineup_CanNotParticipateInMatchay": "Du nimmst an diesem Spieltag nicht teil!\n\nNach diesem Spieltag kannst du deine Mannschaft aufstellen.",
  "Lineup_Formation_FREE": "Freie Aufstellung",
  "Lineup_Formation_FREE_short": "Freie Aufst.",
  "Lineup_Formation_FREE_very_short": "Freie A.",
  "Lineup_PlayerBoostRemoveConfirm": "Willst du den Kapitän runternehmen? Die Karte \"Kapitän\" geht dann verloren.",
  "RankingGroup_UserEmptyGroup": "Du bist noch kein Mitglied in einer Liga",
  "Onboarding_LastButton": "Los geht's!",
  "Onboarding_NextButton": "Weiter",
  "Overlay_ButtonActivate": "Einsetzen",
  "Player_Status_active": "Einsetzbar",
  "Player_Status_inactive": "Nicht einsetzbar",
  "Player_Status_questionable": "Einsatz fraglich",
  "Player_Status_unknown": "Unbekannt",
  "PlayerDetails_SellEstimatedCost": "Einkaufswert:",
  "PlayerFilter_Points": "Letzter Spieltag",
  "PlayerFilter_PointsGameday": "Aktueller Spieltag",
  "PlayerPennant_Description": "Erlaubt zum Einsatz an einem Spieltag",
  "PlayerPennant_Title": "Spielereinsatz",
  "PlayerPosition_free": "freier Taktik",
  "PlayerPosition_groupInLineup": "Aufgestellt",
  "PlayerPosition_groupLocked": "Gesperrte Spieler",
  "PlayerRatingInfo_Title": "Rating",
  "PlayerStats_NextOpponentTitle": "Nächster Gegner",
  "PlayerStats_PositionTitle": "Position",
  "PlayerStats_StatusTitleLineup": "Aufstellung",
  "PlayerStats_StatusTitlePlayer": "Spieler Status",
  "PlayerStats_StatusTitlePreLineup": "Wsl. Aufstellung",
  "PlayerStats_TrendTitle": "Trend",
  "PlayerStatsKey_RatingAndPointsTitle": "Punkte",
  "PlayerStatsKey_StatusText": "Offizielle Daten\nkicker Einschätzung",
  "PlayerStatsKey_StatusTitle": "Status",
  "Ranking_CalculatingList": "Die Tabelle für diesen Spieltag wird gerade berechnet.",
  "Ranking_SegmentGroup": "Liga",
  "Ranking_TableEntry": "{0}. Platz",
  "Ranking_TableEntryShort": "{0}. Pl.",
  "Ranking_TableHeaderPoints": "Punkte",
  "Ranking_TableHeaderPointsRange": "min.-max. Punkte",
  "Ranking_TableHeaderUserCount": "Anzahl der Manager",
  "Ranking_TableHeaderUserName": "Name",
  "Ranking_TableLegendText1": "Stand: {0}",
  "Ranking_TableManagerTitle": "Manager Tabelle",
  "Ranking_TableMyEntryPoints": "Spieltags Punkte",
  "Ranking_TableMyEntryRanking": "Manager Tabelle Platz",
  "Ranking_TableMyEntryRankingNotFound": "Du tauchst in der Tabelle nicht auf. Es ist noch kein Spieltag vergangen an dem Du mitgespielt hast.",
  "Ranking_Title": "Tabelle",
  "Ranking_TopManagersTitle": "Top 3 Manager",
  "RankingGroup_ActionChangeNameButton": "Name ändern",
  "RankingGroup_ActionCreateButton": "Liga gründen",
  "RankingGroup_ActionCreateText": "Gib den Namen für die Liga ein (3-23 Zeichen, keine Sonderzeichen)",
  "RankingGroup_ActionCreateTitle": "Liga gründen",
  "RankingGroup_ActionGenerateJoinLinkButton": "Freunde einladen",
  "RankingGroup_ActionGenerateJoinLinkText": "Verschicke den Link an Freunde, die du einladen möchtest (z.B. per Messenger). Du kannst ihn auch in Gruppen posten, d.h. musst nicht jeden einzeln einladen. Der Link ist bis zum Anpfiff des ersten Saisonspiels gültig. Im Laufe der Saison erstellte Links sind 72 Stunden gültig, danach musst du einen neuen erstellen.",
  "RankingGroup_ActionKickMemberSuccess": "Der User wurde aus der Liga entfernt!",
  "RankingGroup_ActionLeaveButton": "Liga verlassen",
  "RankingGroup_ActionLeaveText": "Willst du wirklich aus der Liga \"{0}\" austreten?",
  "RankingGroup_ActionMakeAdminSuccess": "Der Spieler ist jetzt auch ein Administrator",
  "RankingGroup_ActionManageMembershipText": "Optionen zur Mitgliedsverwaltung",
  "RankingGroup_ActionMemberAssignAdminButton": "Zum Administrator machen",
  "RankingGroup_ActionMemberKickButton": "Entfernen",
  "RankingGroup_ActionMemberRevokeAdminButton": "Administrator-Rechte zurückziehen",
  "RankingGroup_ActionRenameText": "Gib einen neuen Namen für die Liga ein (3-23 Zeichen, keine Sonderzeichen)",
  "RankingGroup_ActionRenameTitle": "Liga umbennen",
  "RankingGroup_ActionRevokeAdminSuccess": "Der Spieler ist keine Administrator mehr",
  "General_NotificationSuccess": "Alles Klar!",
  "RankingGroup_GroupNameInvalid": "Dieser Name ist ungültig",
  "RankingGroup_JoinAlertText": "Möchtest du der Liga beitreten?",
  "RankingGroup_JoinAlertTitle": "Liga beitreten",
  "RankingGroup_JoinLinkShareTitle": "Einladung zur Liga",
  "RankingGroup_NewOrInactiveMembers": "Mitglieder ohne Wertung",
  "RankingGroup_NoMembershipText": "Gründe eine Liga und spiele mit deinen Freunden.",
  "RankingGroup_NotificationGroupJoined": "Liga beigetreten",
  "RankingGroup_ValidationAlreadyMember": "Du bist schon in zu vielen Ligen Mitglied. Du hast die maximale Anzahl an Ligen (10 Teilnahmen) bereits erreicht.",
  "RankingGroup_ValidationAuthorizationFailed": "Keine Berechtigung",
  "RankingGroup_ValidationInvalidGroupName": "Ungültiger Ligenname. Länge zwischen 3 - 32 Zeichen, Sonderzeichen sind nicht erlaubt.",
  "RankingGroup_ValidationInvalidToken": "Du kannst der Liga nicht beitreten. Wahrscheinlich ist der Einladungslink abgelaufen. Bitte den Administrator der Liga, dir einen neuen Link zu schicken. Eine Liga kann maximal 1000 Mitglieder haben.",
  "Roster_ConfirmSellAllPlayers": "Willst du wirklich Dein ganzes\nTeam verkaufen und alle deine Spielereinsätze selbst kaufen und aufstellen für den nächsten Spieltag?",
  "Roster_HodlAllButton": "Behalten",
  "Roster_MyRoster": "Kader öffnen",
  "Roster_OKButton": "Weiter",
  "Roster_PlayerIsLocked": "Dieser Spieler befindet sich in der Transfersperre. Drücke auf \"OK\" um zu seinem Profil zu wechseln.",
  "Roster_PlayerIsUnclaimed": "Dieser Spieler ist nicht aktiviert. Drücke auf \"OK\" und aktiviere ihn im Profil.",
  "Roster_SellAllButton": "Alle verkaufen",
  "Roster_SellAllPlayersSuccessText": "Alle deine Spielereinsätze wurden verkauft",
  "Roster_SellAllPlayersSuccessTitle": "Erledigt!",
  "RosterList_EmptyPositionUsedElsewhere": "Alle Spieler sind aufgestellt oder gesperrt.",
  "RoundEvaluation_ClaimReward": "Belohnung einlösen",
  "RoundEvaluation_MainTitle": "Auswertung",
  "RoundEvaluation_ReviewReward": "Belohnung ansehen",
  "RoundEvaluation_ShowStatistics": "Aufstellung anzeigen",
  "RoundEvaluation_Statistics_BenchPlayers": "Auf der Ersatzbank: {0}/{1}",
  "RoundEvaluation_Statistics_Formation": "Taktik",
  "RoundEvaluation_Statistics_Points": "Punkte",
  "RoundEvaluation_Statistics_RatedPlayers": "Bewertet: {0}/{1}",
  "RoundEvaluation_TopPlayersHeadline": "Deine Top {0}",
  "SellPlayer_IsInLineupConfirm": "Dieser Spieler ist gerade aufgestellt. Willst du den Spieler aus der Aufstellung nehmen und verkaufen?",
  "Shop_CurrencyConversionHeadline": "Währung tauschen",
  "Shop_CurrencyConversionInfo_One": "Letztes Angebot",
  "Shop_CurrencyConversionInfo_Other": "Noch {0} Angebote",
  "Shop_CurrencyConversionText": "Mit jedem Umtausch steigt der Preis des Angebotes. Die Anzahl der Angebote ist begrenzt. Die Angebote werden nach jedem Spieltag zurückgesetzt.",
  "StatusInformation_Title": "Status Information",
  "Timeline_ForceSell": "Dieser Spieler muss zwangsverkauft werden!",
  "Timeline_PlayerLock": "Transfersperre",
  "Transfer_InvalidTutorialPlayerSelection": "Dieser Spieler ist kein Stürmer",
  "Transfer_TeamsLabel": "Teams",
  "Transfer_TransferTitle": "Transfermarkt",
  "UserPhotoOverlay_CameraButton": "Kamera",
  "UserPhotoOverlay_Description": "Willst du ein Foto mit der Kamera aufnehmen oder aus Fotogalerie wählen?",
  "UserPhotoOverlay_PhotoLibraryButton": "Fotogalerie",
  "UserPhotoOverlay_Title": "Benutzerbild",
  "UserSettings_AccountTransferButton": "Geräte verknüpfen",
  "UserSettings_AccountTransferEnterCodeText": "Gib den Code vom alten Gerät ein",
  "UserSettings_AccountTransferEnterCodeTitle": "Code eingeben",
  "UserSettings_AccountTransferFailed": "Geräte-Verknüpfung ist fehlgeschlagen!",
  "UserSettings_AccountTransferNewDevice": "Neues Gerät",
  "UserSettings_AccountTransferOldDevice": "Altes Gerät",
  "UserSettings_AccountTransferText": "Wähle die passende Option für die Verknüpfung aus.\nDas ist dein:",
  "UserSettings_CodeGeneratorFailed": "Code-Generierung fehlgeschlagen!",
  "UserSettings_ConnectedToGameCenter": "Mit GameCenter verbunden",
  "UserSettings_ConnectToGameCenterButton": "Mit GameCenter verbinden",
  "UserSettings_DataProtectionButton": "Datenschutz",
  "UserSettings_DisconnectFromCurrentAccount": "<color=#ff0000>Der Zugriff zu dem aktuellen Benutzer\n<b>{0}</b>\nwird verloren gehen",
  "UserSettings_FAQButton": "FAQ",
  "UserSettings_ImprintButton": "Impressum",
  "UserSettings_InvalidUserName": "Ungültiger Benutzername. Länge zwischen 3 - 32 Zeichen, Sonderzeichen sind nicht erlaubt.",
  "UserSettings_MusicButton": "Musik",
  "UserSettings_RequestDebugging": "Request Debugging",
  "UserSettings_SFXButton": "SFX",
  "UserSettings_SupportButton": "Support",
  "UserSettings_TermsButton": "AGB",
  "UserSettings_TutorialButton": "Tutorial ansehen",
  "UserSettings_UserImageUploadFailed": "Hochladen vom Bild ist fehlgeschlagen",
  "UserSettings_YourCodeTitle": "Code für das neue Gerät",
  "UserSettings_YourProfile": "Dein Profil",
  "ActionMenu_ShareLineup": "Aufstellung teilen",
  "ActionMenu_ShowOpponentLineup": "Aufstellung anzeigen",
  "ActionMenu_ShowRoundEvaluation": "Auswertung anzeigen",
  "Gameloop_ConsolationGift": "Trostpreis",
  "Gameloop_DuelConsolationDescription": "Battle Streak verloren",
  "Gameloop_DuelWinnerDescription": "Dein {0}. Sieg!",
  "Gameloop_DuelWinnerTitle": "Battle gewonnen",
  "Gameloop_ForceSell": "Zwangsverkauf",
  "Gameloop_GroupRankingRewardGift": "Deine Liga",
  "Gameloop_RankingRewardGift": "Manager Tabelle",
  "General_Respond": "Antworten",
  "GeneralDate_CountdownOfferTextEnds_One": "Angebot endet in {0}",
  "LineupShare_Text": "Guck Dir meine Aufstellung an! {0}",
  "LineupShare_Title": "Matchday-Aufstellung",
  "RankingGroup_ActionMemberDetails": "Details anzeigen",
  "RankingGroup_TableHeaderLevel": "Level",
  "Roster_CanOnlySellInGeneralLoop": "Aufgestellte Spielereinsätze können gerade nicht verkauft werden!",
  "UserSettings_GeneralSuccess": "Sieht gut aus!",
  "UserSettings_NotificationsTitle": "Alarm",
  "UserSettings_OnboardingButton": "Updates",
  "UserSettings_UserImageUploadSuccess": "Dein Bild wurde aktualisiert",
  "Banner2_Title_Bold_1": "Beste 2. Liga",
  "Banner2_Title_Bold_2": "Beste Managerspiel!",
  "Banner2_Title_Light_1": "Die",
  "Banner2_Title_Light_2": "Aller zeiten verdient das",
  "Banner_Button": "Jetzt Loslegen",
  "Banner_Description": "Probier den Matchday-Manager vom kicker aus!",
  "Banner_Title": "Jedes Wochenende live wechseln?",
  "BuyPlayer_InsufficientFunds": "Du hast nicht genug Budget, um {0}. für einen Spieler auszugeben.",
  "BuyPlayer_NoMarketValue": "Dieser Spieler besitzt (noch) keinen Marktwert.",
  "Error_TransferLoginWithKicker": "Dieser Account nimmt bereits am Managerspiel teil. Die vorläufige Mannschaft wurde nicht übertragen.",
  "ErrorOverlay_SubTitle": "Das Spiel konnte wegen eines Fehlers nicht gestartet werden",
  "FavoriteList_Add": "Auf den Merkzettel setzten",
  "FavoriteList_EmptyPosition": "Diese Position ist leer",
  "FavoriteList_IsFullText": "Der Merkzettel ist voll!",
  "FavoriteList_Remove": "Vom Merkzettel streichen",
  "Favorites_FavoritesTitle": "Merkzettel",
  "General_ErrorRestart": "Die Aktion konnte nicht ausgeführt werden.\nDas Spiel wird neugestartet.",
  "General_MoreInformation": "Mehr Informationen",
  "General_NotFound": "Nicht gefunden",
  "General_SomethingWentWrong": "Etwas ist schief gelaufen",
  "Global_MillionsAbbreviation": "Mio",
  "Lineup_AdditionalInformationPoints": "Punkte",
  "Lineup_AdditionalInformationAssignments": "Einsätze",
  "Lineup_AdditionalInformationPrice": "Marktwert",
  "Lineup_AdditionalInformationRating": "Gesamt",
  "Lineup_AdditionalInformationPointsRound": "Letzter Spieltag",
  "Lineup_AdditionalInformationPointsRating": "Saison",
  "Lineup_AdditionalInformationPointOnMyAssignments": "für mich",
  "Lineup_AdditionalInformationAssignmentsMyAssignments": "für mich",
  "Lineup_AdditionalInformationAssignmentsTotal": "Saison",
  "Lineup_AdditionalInformationAssignmentsAveragePerAssignments": "Punkte pro Einsatz",

  "Lineup_BuyPlayers": "Spieler kaufen",
  "Lineup_CanNotChangeLineupDuringCurrentPhase": "Aufstellung",
  "Lineup_Committed": "Kader gespeichert",
  "Lineup_CommittedToBench": "Ersatzbank",
  "Lineup_CommittedToField": "Aufgestellt",
  "Lineup_EmptyBench": "Leer",
  "Lineup_EmptyLineupMessage": "Du hast noch keine Aufstellung",
  "Lineup_GameloopStateLocked": "Transfermarkt ist gesperrt",
  "Lineup_HideBench": "Ersatzbank verstecken",
  "Lineup_Legend": "Legende",
  "Lineup_LegendActive": "Startelf",
  "Lineup_LegendActualLineup": "Tatsächliche Aufstellung",
  "Lineup_LegendBench": "Ersatzbank",
  "Lineup_LegendColors": "Farben",
  "Lineup_LegendForecast": "Voraussichtliche Aufstellung",
  "Lineup_LegendInactive": "Nicht im Kader",
  "Lineup_LegendPictograms": "Symbole",
  "Lineup_LegendQuestionable": "Einsatz fraglich",
  "Lineup_LegendTeamTransfer": "Teamwechsel",
  "Lineup_LegendTeamTransferLeftSeason": "Wettbewerb verlassen",
  "Lineup_LegendTeamTransferOriginTeam": "Team zum Kaufzeitpunkt",
  "Lineup_LegendTeamTransferRemainedInSeason": "Im Wettbewerb geblieben",
  "Lineup_MaxForTeam": "Du hast Bereits drei {team.name} Spieler in deiner Aufstellung.",
  "Lineup_MaxForTeamTitle": "Maximale Anzahl an Spielern erreicht",
  "Lineup_RandomRoster": "Zufälliger Kader",
  "Lineup_ShareOption1": "Post / Messenger (1:1)",
  "Lineup_ShareOption2": "Story - Kader (9:16)",
  "Lineup_ShareOption3": "Story - Ersatzbank (9:16)",
  "Lineup_ShareOption4": "Print (DIN A4)",
  "Lineup_ShareTitle": "Kader teilen",
  "Lineup_ShowBench": "Ersatzbank anzeigen",
  "Lineup_Substitute": "Wechseln",
  "Lineup_SubstitutionDone": "Fertig",
  "LoadingOverlay_Database": "Spiele und Spieler werden geladen…",
  "LoadingOverlay_Login": "Einloggen…",
  "LoadingOverlay_RedirectToSeason": "Weiterleiten zur Saison…",
  "LoadingOverlay_SeasonData": "Liga wird geladen…",
  "MatchState_Halted": "abges.",
  "Navigation_GlobalRanking": "Rangliste",
  "Navigation_Group": "Ligen",
  "Navigation_Lineup": "Aufstellung",
  "Navigation_Live": "Spieltag",
  "Navigation_TransferMarket": "Transfermarkt",
  "Navigation_Classic": "Managerspiel Classic",
  "Navigation_Interactive": "Managerspiel Interactive",
  "NetworkErrorVerifyEmailAddress": "Bitte die E-Mail-Adresse deines kicker-Accounts bestätigen.",
  "PlayerCard_Position": "Position",
  "PlayerCard_Price": "Marktwert",
  "PlayerCard_PriceByRating": "Punkte / Marktwert",
  "PlayerDetails_Grade": "Grade",
  "PlayerDetails_Match": "Einsatz",
  "PlayerDetails_Matches": "Einsätze",
  "PlayerDetails_Per_Match": "pro Einsatz",
  "PlayerDetails_Point": "Punkt",
  "PlayerDetails_Points": "Punkte",
  "PlayerDetails_PointsAssists": "Assists",
  "PlayerDetails_PointsAverageGrade": "kicker-Note ⌀",
  "PlayerDetails_PointsBreakdown": "Punkte Kriterium",
  "PlayerDetails_PointsCard": "Platzverweis",
  "PlayerDetails_PointsCards": "Platzverweise",
  "PlayerDetails_PointsCardsRed": "Rot",
  "PlayerDetails_PointsCardsYellowRed": "Gelb-Rot",
  "PlayerDetails_PointsCardsYellowRedAndRed": "Gelb-Rot/Rot",
  "PlayerDetails_PointsCleanSheet": "Zu Null",
  "PlayerDetails_PointsGoals": "Tore",
  "PlayerDetails_PointsGrade": "kicker-Note",
  "PlayerDetails_PointsJoker": "Einwechslung",
  "PlayerDetails_PointsJokers": "Einwechslungen",
  "PlayerDetails_PointsMVP": "Spieler des Spiels",
  "PlayerDetails_PointsStarter": "Startaufstellung",
  "PlayerDetails_PointsStarters": "Startaufstellungen",
  "PlayerDetails_ProfileLink": "Steckbrief",
  "PlayerDetails_RoundRating": "Spieltagswertung",
  "PlayerDetails_SeasonRating": "Saisonwertung",
  "PlayerDetails_Stats": "Saisonstatistik",
  "PlayerFilter_SearchByName": "Suche nach Spielernamen…",
  "Ranking_EmptyList": "Keine Einträge vorhanden",
  "Ranking_NoRankingsAvailable": "Keine Rangliste verfügbar",
  "Ranking_SeasonNotStarted": "Es ist noch keine Spielrunde in der Saison vergangen.",
  "Ranking_SegmentRound": "Spieltagswertung",
  "Ranking_SegmentSeason": "Saisonwertung",
  "Ranking_SegmentRound_UserDetail": "Spieltagspunkte",
  "Ranking_SegmentSeason_UserDetail": "Saisonpunkte",
  "Ranking_TableHeaderRank": "Platz",
  "RankingGroup_ActionChangeNameSuccessText": "Der neue Name der Liga wurde gespeichert",
  "RankingGroup_ActionChangeNameSuccessTitle": "Ligen",
  "RankingGroup_ActionCopyButton": "In die Zwischenablage kopieren",
  "RankingGroup_ActionCopySuccess": "Fertig!",
  "RankingGroup_ActionCopySuccessText": "Link wurde kopiert",
  "RankingGroup_ActionGenerateJoinLinkDescription": "Verschicke den Einladungs-Link and deine Freunde, Bekannte und Kollegen.",
  "RankingGroup_ActionKickMemberText": "{0} entfernen?",
  "RankingGroup_ActionLeaveSuccessText": "Du bist aus der Liga ausgetreten.",
  "RankingGroup_ActionLeaveSuccessTitle": "Fertig!",
  "RankingGroup_ActionMakeAdminText": "Make {0} an admin?",
  "RankingGroup_ActionShareButton": "Teilen",
  "Roster_ExportAllPlayers": "Spieler-Daten Export",
  "Roster_FillUpPlayers": "Kader automatisch auffüllen",
  "Roster_FillUpPlayersImpossible": "Das Budget reicht nicht aus",
  "Roster_SellAllPlayers": "Alle verkaufen",
  "Roster_SellAllPlayersWarning": "Willst du deinen gesamten Kader verkaufen?",
  "Roster_WinterTransferButton": "Meine Transfers",
  "RoundResult_PointsMaximum": "Top-Team",
  "RoundResult_PointsMissedOut": "Verpasst",
  "RoundResult_YourPoints": "Erreicht",
  "RulesHelp_Budget": "Deine Mannschaft muss aus exakt {0} Spielern bestehen, um an der Wertung teilzunehmen. Das Budget muss nicht vollständig ausgegeben werden.",
  "RulesHelp_GameLocked": "Der Transfermarkt ist geschlossen. Im Moment kannst du keine Kaderveränderungen vornehmen.",
  "RulesHelp_PlayerWarning": "Spieler, die nicht zum Einsatz kommen, können keine Punkte sammeln. Bitte überprüfe deine Aufstellung und passe sie gegebenenfalls an.",
  "RulesHelp_Title": "Hinweis",
  "RulesHelp_TradesLeft": "Deine Transfers im Transferfenster. Wenn du einen Verkauf rückgängig machen willst, klicke auf das Spielerprofil.",
  "RulesHelp_TradesLeftBoughtPlayers": "Spieler gekauft",
  "RulesHelp_TradesLeftSoldPlayers": "Spieler verkauft",
  "RulesHelp_TransferMarketLocked": "Der Transfermarkt ist aktuell geschlossen. Der Kader kann nur während eines geöffneten Transferfensters verändert werden.",
  "RulesHelp_WinterTransfer": "Im Transferfenster hat jeder Manager die Möglichkeit, den Kader etwas zu verändern.",
  "Stats_Filter": "Filter",
  "Stats_Matchday": "Matchday",
  "Stats_MillionsAbbreviation": "M",
  "Stats_OrderByPopularity": "Beliebtheit",
  "Stats_OrderByPrice": "Preis",
  "Stats_OrderByPricePointRatio": "Preis-Punkte Verhältnis",
  "Stats_OrderByRating": "Bewertung",
  "Stats_OrderByStatus": "Status",
  "Stats_Position": "Position",
  "Stats_PoweredBy": "Powered By",
  "Stats_Team": "Team",
  "Stats_Timeframe": "Zeitraum",
  "Stats_Title": "Stats",
  "StatusBar_Balance": "Mein Budget",
  "StatusBar_EvaluatingRound": "Spieltag wird berechnet",
  "StatusBar_InactiveSeason": "Vergangene Saison",
  "StatusBar_PlayerCount": "Mein Kader",
  "StatusBar_PlayerWarning": "Fragliche Spieler aufgestellt",
  "StatusBar_PointsReached": "Erreichte Punkte",
  "StatusBar_TradesLeft": "Transfers",
  "StatusBar_Transfermarket": "Transfermarkt",
  "StatusBar_TransfermarketLocked": "Geschlossen",
  "StatusBar_TrialAccount": "Nicht angemeldet",
  "Transfer_FilterAllTeams": "Alle Teams",
  "TransferMarket_FullBench": "Deine Ersatzbank ist voll, bitte ändere deine Aufstellung bevor du wieder einkaufst.",
  "TransferMarket_FullBenchTitle": "Ersatzbank ist voll",
  "TransferMarket_FullLedger": "Du kannst keinen weiteren Spieler für die Position {position} kaufen.",
  "TransferMarket_FullLedgerTitle": "Kader voll",
  "TransferMarket_MarketNotOpen": "Der Transfermarkt ist geschlossen",
  "TransferMarket_MaxForTeam": "Du kannst keinen weiteren Spieler von {team} kaufen.",
  "TransferMarket_MaxForTeamOnPitch": "Du kannst keinen weiteren Spieler von {team} kaufen. Auf dem Spielfeld sind bereits 3 Spieler platziert.",
  "TransferMarket_MaxForTeamOnPitchTitle": "Maximale Spielerzahl erreicht (auf dem Spielfeld)",
  "TransferMarket_MaxForTeamTitle": "Maximale Spielerzahl erreicht",
  "TransferMarket_NoRestrictedSalesLeft": "Verkaufslimit der Transfers ist bereits erreicht.",
  "TransferMarket_NoRestrictedSalesLeftTitle": "Verkauf ist nicht möglich",
  "TransferMarket_OrderByFirstName": "Sortieren nach Vorname",
  "TransferMarket_OrderByFirstName_selected": "Vorname",
  "TransferMarket_OrderByLastName": "Sortieren nach Nachname",
  "TransferMarket_OrderByLastName_selected": "Nachname",
  "TransferMarket_OrderByPoints": "Sortieren nach Punkten (letzter Spieltag)",
  "TransferMarket_OrderByPoints_selected": "Punkte (letzter Spieltag)",
  "TransferMarket_OrderByPrice": "Sortieren nach Marktwert",
  "TransferMarket_OrderByPrice_selected": "Marktwert",
  "TransferMarket_OrderByRating": "Sortieren nach Punkten (gesamt)",
  "TransferMarket_OrderByRating_selected": "Punkte (gesamt)",
  "TransferMarket_WinterTransferClosesAt": "Transferfenster schließt in",
  "TransferMarket_WinterTransferClosesOn": "Transferfenster schließt am",
  "TransferMarket_WinterTransferNoTransactions": "Leer",
  "TransferMarket_WinterTransferOpensAt": "Transferfenster öffnet in",
  "TransferMarket_WinterTransferOpensOn": "Transferfenster öffnet am",
  "TransferMarket_WinterTransferTransaction": "Meine Transfers",
  "TrendText_down": "Verschlechtert",
  "TrendText_missing": "Wird berechnet",
  "TrendText_unchanged": "Unverändert",
  "TrendText_undefined": "Neu dabei",
  "TrendText_up": "Verbessert",
  "GroupViewLegend": {
    "GroupMemberLedgerState": {
      "FULL": "Kader startklar",
      "EMPTY_OR_PARTIAL": "Kader in Arbeit",
      "NONE": "noch kein Kader"
    }
  },
  "UserDetails_Points": "Punkteübersicht",
  "UserDetails_TotalPoints": "Gesamt",
  "UserDetails_AveragePoints": "Punkte Ø",
  "UserDetails_MissedPoints": " / Verpasst"
}
